// URLs Alfresco de base
// Utiliser le serveur proxy Node.js sur port 3001 pour éviter les problèmes CORS
export const ALFRESCO_BASE_URL = process.env.REACT_APP_ALFRESCO_URL || 'https://ged.dev.addinn-group.com/alfresco';
export const ALFRESCO_API_URL = `${ALFRESCO_BASE_URL}/api/-default-/public`;
export const ALFRESCO_SERVICE_URL = process.env.REACT_APP_ALFRESCO_SERVICE_URL || 'https://ged.dev.addinn-group.com/alfresco/service';
export const ALFRESCO_LEGACY_API_URL = `${ALFRESCO_BASE_URL}/s/api`;

// Endpoints API Alfresco Public API
export const API_ENDPOINTS = {
  // Authentication API legacy
  LOGIN: `${ALFRESCO_BASE_URL}/service/api/login`,
  // Workflow API v1
  WORKFLOW: {
    TASKS: `${ALFRESCO_API_URL}/workflow/versions/1/tasks`,
    TASK_FORM: (taskId) => `${ALFRESCO_API_URL}/workflow/versions/1/tasks/${taskId}/form`,
    COMPLETE_TASK: (taskId) => `${ALFRESCO_API_URL}/workflow/versions/1/tasks/${taskId}`,
    PROCESSES: `${ALFRESCO_API_URL}/workflow/versions/1/processes`
  },
  // Custom BIAT WebScripts (via service)
  BIAT: {
    START_AUTO: '/biat/workflow/start-auto',
    TASK_FORM: (taskId) => `/biat/workflow/task/${taskId}/form`,
    COMPLETE_TASK: (taskId) => `/biat/workflow/task/${taskId}/complete`,
    WORKFLOW_VARIABLES: (processId) => `/biat/workflow/${processId}/variables`,
    STATS: {
      GLOBAL: '/biat/stats/global',
      BY_STATUS: '/biat/stats/by-status',
      BY_AGENT: '/biat/stats/by-agent',
      WORKFLOW_HISTORY: '/biat/stats/workflow-history'
    }
  },
  // People API
  PEOPLE: (username) => `${ALFRESCO_BASE_URL}/api/-default-/public/alfresco/versions/1/people/${username}`,
  PEOPLE_ME: `${ALFRESCO_BASE_URL}/api/-default-/public/alfresco/versions/1/people/-me-`
};

// Constantes de l'application
export const APP_NAME = 'BIAT Assurance - Gestion des Workflows';
export const TASK_STATES = {
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED'
};

// Clés de stockage local
export const STORAGE_KEYS = {
  ALFRESCO_TICKET: 'alfresco_ticket',
  USER_INFO: 'user_info'
};

